import { SKILL_SYNC_STALE_MS } from "../../shared/mutators/resyncSkill";
import { useDeadlinePassed } from "./useDeadlinePassed";

export function useSkillSyncInProgress(
  syncStartedAt: number | null | undefined
): boolean {
  const stale = useDeadlinePassed(
    syncStartedAt != null ? syncStartedAt + SKILL_SYNC_STALE_MS : null
  );
  return syncStartedAt != null && !stale;
}
